/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  Condition,
  ErrorResponse,
  Sorting,
  StoreScheduleCreateRequest,
  StoreScheduleResponseCollectionResponse,
  StoreScheduleResponseDataResponse,
  StoreScheduleUpdateRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class StoreSchedules<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags StoreSchedules
   * @name GetStoreSchedules
   * @request GET:/StoreSchedules
   * @response `200` `StoreScheduleResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getStoreSchedules = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreScheduleResponseCollectionResponse, ErrorResponse>({
      path: `/StoreSchedules`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags StoreSchedules
   * @name CreateStoreSchedule
   * @request POST:/StoreSchedules
   * @response `200` `StoreScheduleResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  createStoreSchedule = (data: StoreScheduleCreateRequest, params: RequestParams = {}) =>
    this.http.request<StoreScheduleResponseDataResponse, ErrorResponse>({
      path: `/StoreSchedules`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags StoreSchedules
   * @name GetStoreSchedule
   * @request GET:/StoreSchedules/{id}
   * @response `200` `StoreScheduleResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getStoreSchedule = (id: number, params: RequestParams = {}) =>
    this.http.request<StoreScheduleResponseDataResponse, ErrorResponse>({
      path: `/StoreSchedules/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags StoreSchedules
   * @name PutStoreSchedule
   * @request PUT:/StoreSchedules/{id}
   * @response `200` `StoreScheduleResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  putStoreSchedule = (id: number, data: StoreScheduleUpdateRequest, params: RequestParams = {}) =>
    this.http.request<StoreScheduleResponseDataResponse, ErrorResponse>({
      path: `/StoreSchedules/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags StoreSchedules
   * @name DeleteStoreSchedule
   * @request DELETE:/StoreSchedules/{id}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteStoreSchedule = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/StoreSchedules/${id}`,
      method: 'DELETE',
      ...params,
    });
}
